
const svg = require(`~/assets/brands/${process.env.AGENT}/logo-login.svg`);

export default {
	name: 'logologin',
	data() {
		return {svg: typeof svg === 'string' ? svg : svg.default || ''};
	}
};
